import { lazy, useEffect, useMemo, useRef } from 'react';
import { useRouterState } from '@tanstack/react-router';
import { useCommandScope } from '@dataroom/interaction';
import { useAiAvailability } from '../ai/availability';
import { copilotScope } from '../features/copilot/commands';
import { defineGlobalLayer, openLayer } from '../shell/overlays';
/** The copilot's shortcut and deep link exist only for signed-in members (never on `_public` routes
 *  such as a page published to the web, where an AI status probe would answer 401). */
function CopilotEntry() {
  const isPublic = useRouterState({
    select: (s) => s.matches.some((m) => m.routeId === '/_public' || m.routeId.startsWith('/_public/')),
  });
  return isPublic ? null : <SignedInCopilotEntry />;
}
function SignedInCopilotEntry() {
  const availability = useAiAvailability();
  const ready = useRef(false);
  const limited = useRef(false);
  ready.current = availability.ready;
  limited.current = availability.state === 'limited';
  const ctx = useMemo(() => ({ available: () => ready.current, limited: () => limited.current }), []);
  useCommandScope(copilotScope, { ctx });
  const search = useRouterState({ select: (s) => s.location.searchStr });
  const thread = new URLSearchParams(search).get('copilotThread');
  const turn = new URLSearchParams(search).get('copilotTurn');
  useEffect(() => {
    if (thread) openLayer('copilot', { scope: { threadId: thread, turnId: turn } });
  }, [thread, turn]);
  return null;
}
export default defineGlobalLayer({
  id: 'copilot',
  component: lazy(() => import('../features/copilot/CopilotPanel')),
  Effect: CopilotEntry,
});
